import { useLottie } from "lottie-react";
import searching from "./Searching.json";

const SearchLottie = () => {
  const options = {
    animationData: searching,
    loop: true,
    style: {
      height: "25px",
      width: "25px",
    },
    className: "lottie-animation",
  };
  const { View } = useLottie(options);
  return <>{View}</>;
};
export default SearchLottie;
